import AddIcons from '@/icons/AddIcons'
import { IconButton, Typogaphy } from 'vnetwork-ui'
import { FieldValues, Controller, Path, UseFormReturn } from 'react-hook-form'

interface ImageInputProps<T extends FieldValues> {
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    type: 'avatar' | 'image'
    handleInput: () => void
    size?: string
    height?: string
    width?: string
    objectFit?: string
}

const ImageForm = <T extends FieldValues>({
    control,
    name,
    type,
    size = '160px',
    height = '160px',
    width = '160px',
    // objectFit = 'cover',
    handleInput,
}: ImageInputProps<T>) => {
    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { value }, fieldState: { error } }) => (
                <div className="grid grid-col-1" onClick={() => handleInput()}>
                    <div className="w-full flex items-center justify-center">
                        <div
                            className={`${type === 'avatar' && 'rounded-full'} border flex items-center overflow-hidden`}
                            style={{
                                width: `${type === 'avatar' ? size : width}`,
                                height: `${type === 'avatar' ? size : height}`,
                            }}
                        >
                            {value ? (
                                <img
                                    className={`w-full h-full ${type === 'avatar' && 'rounded-full'}`}
                                    src={value}
                                    alt="Avatar"
                                    style={{
                                        width: `100%`,
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                            ) : (
                                <IconButton className="h-full w-full">
                                    <AddIcons />
                                </IconButton>
                            )}
                        </div>
                    </div>
                    {error && (
                        <div className="flex justify-center w-full">
                            <Typogaphy size="small" className="text-red-500">
                                {error?.message}
                            </Typogaphy>
                        </div>
                    )}
                </div>
            )}
        />
    )
}
export default ImageForm
